<template>
  <a-modal width="65%" title="导入点位记录" v-model="visibleModal" @cancel="close">
    <a-table
      :columns="columns"
      :dataSource="tableData"
      class="update-table"
      :pagination="false"
      :scroll="{ x: 900, y: 500 }"
    >
      <span slot="operate" slot-scope="row">
        <a v-if="row.errorCount>0" target="_blank" :href="row.resultUrl">下载失败点位</a>
        <span v-else>--</span>
      </span>
    </a-table>
    <div class="pagination-wrap">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="total"
        :pageSize="pageSize"
        v-model="current"
        show-size-changer
        :show-total="total => `共${total}条 `"
        @showSizeChange="onShowSizeChange"
        @change="changePage"
      >
      </a-pagination>
    </div>
    <template slot="footer">
      <a-button @click="close">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
import api from "../../../commomFun/api.js";
export default {
  name: "UpdateHistoryModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    visible(val) {
      this.visibleModal = val
      val && this.getRecord()
    },
  },
  data() {
    return {
      visibleModal: false,
      columns: [
        {
          title: "导入时间",
          key: "importDate",
          dataIndex: "importDate",
          width: 180,
          ellipsis: true
        },
        {
          title: "导入文件名称",
          key: "name",
          dataIndex: "name",
          width: 180,
          ellipsis: true
        },
        {
          title: "导入结果",
          key: "code",
          dataIndex: "code",
          width: 100,
          customRender: (text, record, index)=>{return text==1?'处理完成':'处理中'}
        },
        {
          title: "导入总体数量",
          key: "totalCount",
          dataIndex: "totalCount",
          align: 'right',
          width: 120
        },
        {
          title: "新建成功数量",
          key: "createCount",
          dataIndex: "createCount",
          align: 'right',
          width: 120
        },
        {
          title: "更新成功数量",
          key: "updateCount",
          dataIndex: "updateCount",
          align: 'right',
          width: 120
        },
        {
          title: "失败数量",
          key: "errorCount",
          dataIndex: "errorCount",
          scopedSlots: { customRender: "errorCount" },
          align: 'right',
          width: 100
        },
        {
          title: "操作",
          width: 150,
          scopedSlots: { customRender: "operate" }
        },
      ],
      tableData: [],
      // 分页
      pageSizeOptions: ['10', '20', '30', '40'],
      current: 1,
      pageSize: 10,
      totalPage: 0,
      total: 0
    };
  },
  methods: {
    changePage(page, pageSize) {
      this.pageSize = pageSize
      this.current = page
      this.getRecord()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.getRecord()
    },
    getRecord() {
      api.getApiSpecil("/platform/point/pagePointImplortRecord", {
        pageNum: this.current,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.data.code == 200 || res.data.data) {
          let data = res.data.data
          this.tableData = data.list || []
          this.tableData.forEach((item, index) => {
            item.key = index
          });
          [this.totalPage, this.total] = [data.totalPage, data.total]
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    close() {
      this.$emit("close")
    },
  },
};
</script>
<style lang="scss" scoped>
  .pagination-wrap {
    margin-top: 16px;
    background: #fff;
    height: 32px;
    text-align: right;
  }
</style>
